import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IntervalEnum } from '@modules/filters/enums';

const errorMessage = {
  [IntervalEnum.Week]: {
    startDate: 'Please select the first date of this week (Sunday)',
    endDate: 'Please select the last date of this week (Saturday)',
  },
  [IntervalEnum.Month]: {
    startDate: 'Please select the first date of the month',
    endDate: 'Please select the last date of the month',
  },
};

export type DateRangeIntervalValue = IntervalEnum | { value: IntervalEnum };

export function dateRangeCustomValidator(
  intervalValue: DateRangeIntervalValue,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.pristine) {
      return null;
    }

    if (
      !control.value ||
      !Array.isArray(control.value) ||
      control.value.length !== 2
    ) {
      return null;
    }

    const [startDate, endDate] = control.value;
    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
      return null;
    }

    const errors: ValidationErrors = {};

    const interval =
      typeof intervalValue === 'object' && intervalValue !== null
        ? intervalValue.value
        : intervalValue;
    if (interval === IntervalEnum.Month) {
      if (startDate.getDate() !== 1) {
        errors.startDate = errorMessage[IntervalEnum.Month].startDate;
      }

      const lastDay = new Date(
        endDate.getFullYear(),
        endDate.getMonth() + 1,
        0,
      ).getDate();
      if (endDate.getDate() !== lastDay) {
        errors.endDate = errorMessage[IntervalEnum.Month].endDate;
      }
    } else if (interval === IntervalEnum.Week) {
      if (startDate.getDay() !== 0) {
        errors.startDate = errorMessage[IntervalEnum.Week].startDate;
      }

      if (endDate.getDay() !== 6) {
        errors.endDate = errorMessage[IntervalEnum.Week].endDate;
      }
    }

    return Object.keys(errors).length ? { error: errors } : null;
  };
}
